<template>
  <div class="demand">
    <div class="demand-head flex flex-row flex-between">
      <div class="demand-name">{{ data.demandTitle }}</div>
      <!-- <div class="demand-time">{{ data.createTime }}</div> -->
    </div>
    <div class="demand-con flex flex-row">
      <div class="flex-1">
        <div class="demand-list demand-pro">
          <!-- <span class="icon icon-menu"><i class="el-icon-menu"></i></span> -->
          <img
            class="demand-testicon"
            src="@/assets/icon-bg/text-icon.png"
            alt=""
          />
          <label>检测项：</label><span>{{ data.demandProjectName }}</span>
        </div>
        <div class="demand-list demand-pro">
          <span class="icon icon-location"
            ><i class="el-icon-location"></i
          ></span>
          <label>地&nbsp;&nbsp;&nbsp;址：</label>
          <span>{{ data.demandPublishProvince }}</span>
          <span>{{ data.demandPublishCity }}</span>
          <span>{{ data.demandPublishCounty }}</span>
          <span>{{ data.demandPublishAddress }}</span>
        </div>
        <div class="demand-list">
          <span class="icon icon-time"><i class="el-icon-time"></i></span>
          <label>日&nbsp; &nbsp;期：</label><span>{{ data.createTime }}</span>
        </div>
      </div>
      <div class="demand-btn flex flex-right flex-bottom">
        <el-button type="primary" plain @click="toDetail" size="mini"
          >查看详情</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    // 表格行点击事件
    toDetail() {
      this.$jump.push({
        name: "demandDetail",
        query: { id: this.data.demandId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.icon {
  color: white;
  border-radius: 100%;
  display: inline-block;
  font-size: 12px;
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  margin-right: 5px;
  &-menu {
    background: #15b6fe;
  }
  &-location {
    background: #40d5d5;
  }
  &-time {
    background: #d5406e;
  }
}
.demand {
  // margin-bottom: 23px;
  padding: 8px 0;
  background: white;
  &-head {
    height: 39px;
    line-height: 39px;
    padding-left: 16px;
    padding-right: 16px;
    border-bottom: 1px solid #f3f3f3;
  }
  &-name {
    font-size: 14px;
    font-weight: bold;
    color: #3b3b3b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &-con {
    padding: 15px 16px;
  }
  &-pro {
    margin-bottom: 15px;
  }
  &-testicon {
    width: 18px;
    margin-right: 5px;
  }
}
</style>
